var _defs, _line, _line2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add-circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12,
    y1: 7.5,
    x2: 12,
    y2: 16.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 7.5,
    y1: 12,
    x2: 16.5,
    y2: 12
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12,
    cy: 12,
    r: 11.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.0c1ae4ed1a8b32e1752e8217e6150be5.svg";
export { ForwardRef as ReactComponent };